"use client";

import React, { useState } from "react";
import { FaChevronDown } from "react-icons/fa";

export default function TechFAQ({ techLabel, faqSection }) {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) =>
    setActiveIndex(activeIndex === index ? null : index);

  const defaultFaqs = [
    {
      question: `What services do you offer for ${techLabel}?`,
      answer: `We offer tailored ${techLabel} deployments, architectural optimizations, data workflow pipelines, and cross-platform interface adaptations.`
    },
    {
      question: `What is the standard timeline for development?`,
      answer: `Typical initial phase implementations settle comfortably across 4 to 8 developmental sprint cycles depending on requirements.`
    },
    {
      question: `Will the solution scale effectively across loads?`,
      answer: `Yes, our frameworks deploy multi-node infrastructure pipelines automatically tracking operational growth seamlessly.`
    }
  ];

  const title = faqSection?.title || `Got Questions About ${techLabel}? \n We've Got Answers!`;
  
  // Use backend FAQs if they exist, otherwise use default
  const rawFaqs = faqSection?.faqs?.filter(f => f.question && f.answer) || [];
  const faqs = rawFaqs.length > 0 ? rawFaqs : defaultFaqs;

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto relative z-10">
      <div className="text-center mb-12">
        <span className="text-xs font-bold tracking-widest text-[#f48227] uppercase bg-transparent px-4 py-1.5 rounded-full" style={{ border: "1px solid #f48227" }}>
          Frequently Asked Questions
        </span>
        <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-semibold text-white leading-tight mt-4 mb-4 whitespace-pre-line">
          {title}
        </h2>
      </div>

      <div className="space-y-4">
        {faqs.map((item, index) => {
          const isOpen = activeIndex === index;
          return (
            <div
              key={index}
              style={{ backgroundColor: "#111010d1" }}
              className="rounded-3xl overflow-hidden transition-all duration-300 shadow-xl shadow-black/10 border-0 group"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full flex items-center justify-between p-6 text-left transition-colors duration-200 !bg-[#111010d1] hover:!bg-[#111010d1]"
              >
                <h3 className={`font-semibold text-sm md:text-base transition-all duration-300 group-hover:!text-[#f1833b] group-hover:translate-x-2 transform ${isOpen ? "text-[#f1833b] translate-x-2" : "text-white"}`}>
                  {item.question}
                </h3>
                <div
                  style={{ backgroundColor: "#f1833b" }}
                  className={`w-8 h-8 rounded-xl flex items-center justify-center text-xs flex-shrink-0 text-black transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
                >
                  <FaChevronDown />
                </div>
              </button>

              <div
                className={`transition-all duration-300 ease-in-out overflow-hidden ${isOpen ? "max-h-[500px] opacity-100 p-6 bg-black/20" : "max-h-0 opacity-0"
                  }`}
              >
                <p className="text-gray-300 text-sm leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
